import {
  TGetWhiteLabelGroupAction,
  TGetWhiteLabelGroupThunkAction,
} from "../../../@types/Action/TWhiteLabelGroupAction";
import { TGetWhiteLabelGroupParams } from "../../../@types/Params/TWhiteLabelGroupParams";
import { TGlobalState } from "../../../@types/State/TGlobalState";
import { getWhiteLabelGroupsSelector } from "../../selectors/whiteLabelGroupSelector";
import { whiteLabelGroup } from "../actionTypes";

export const getWhiteLabelGroupsIfNeeded =
  (params: TGetWhiteLabelGroupParams): TGetWhiteLabelGroupThunkAction =>
  async (dispatch, getState): Promise<void> => {
    if (!shouldGetWhiteLabelGroups(getState())) return;

    await dispatch(getWhiteLabelGroups(params));
  };

export const invalidateGetWhiteLabelGroups = (): TGetWhiteLabelGroupAction => ({
  type: whiteLabelGroup.GET_WHITE_LABEL_GROUP_INVALIDATE,
});

export const clearGetWhiteLabelGroups = (): TGetWhiteLabelGroupAction => ({
  type: whiteLabelGroup.GET_WHITE_LABEL_GROUP_CLEAR,
});

export const shouldGetWhiteLabelGroups = (state: TGlobalState): boolean => {
  const { loading, didInvalidate } = getWhiteLabelGroupsSelector(state);
  if (loading || !didInvalidate) return false;
  return true;
};

export const getWhiteLabelGroups =
  (params: TGetWhiteLabelGroupParams): TGetWhiteLabelGroupThunkAction =>
  async (dispatch, _getAction, { campaignService }): Promise<void> => {
    dispatch({ type: whiteLabelGroup.GET_WHITE_LABEL_GROUP_FETCHING });
    try {
      const whiteLabelGroups = await campaignService.getWhiteLabelGroup(params);

      dispatch({
        type: whiteLabelGroup.GET_WHITE_LABEL_GROUP_SUCCESS,
        payload: whiteLabelGroups,
      });
    } catch (error: any) {
      dispatch({ type: whiteLabelGroup.GET_WHITE_LABEL_GROUP_ERROR, error });
    }
  };
